<template>
	<div class="popup_wrpr active" @click.self="$emit('close')">
<!--		<transition name="fade">-->
		<div class="template-panel-popup popup_high_right">

				<Loading v-show="loading"/>

				<a href="#" class="close_popup_btn" @click.prevent="$emit('close')">
					<inline-svg :src="require('@/assets/img/popup_close.svg')"/>
				</a>

				<div class="layout-column">
					<h1 class="popup_title layout-row">
            <span class="flex">
              {{ template.name || '' }}
            </span>
					</h1>
					<span class="flex-none desc">
						{{ template.description || ''}}
					</span>

					<div class="layout-row sub-tags">
						<div class="layout-row uses">
							<inline-svg :src="require('@/assets/img/get-started/screen.svg')" />
							{{short(template.uses)+' '}}
							Uses
						</div>
						<div class="layout-row likes">
							<inline-svg :src="require(`@/assets/img/get-started/heart${template.liked?'-full':''}.svg`)" />
							{{short(template.likes)+' '}}
							Likes
						</div>
					</div>

					<div class="layout-row">
						<v-button label="Use this template" :loading="cloning" @click="cloning=true" :icon="require('@/assets/img/get-started/pen.svg')" />
						<v-button v-if="steps && steps.length" label="Preview" :href="steps?'https://'+steps[0].url+'?utm_source=fnsh&utm_campaign=get-started':''" target="_blank" border :icon="require('@/assets/img/get-started/preview.svg')" />
						<v-button class="like-btn" :class="{liked:template.liked}" label="Like" flat @click="like()"
						          :icon="require(`@/assets/img/get-started/heart${template.liked?'-full':''}.svg`)" />
					</div>
				</div>

			<div class="template-steps scroll">
				<div class="layout-column ">
					<div class="step-thumbnail" v-for="step in steps" :key="step.id">
						<span class="tag">
							<img :src="stepType(step.type).img" />
							{{stepType(step.type).title}}</span>
						<img class="" :src="step.thumbnail_hash"  alt="" />
					</div>
				</div>
			</div>


			<cloning-funnel-popup v-if="cloning&&template" :funnel="template.funnel_id" :code="template.share_code"
			                      :name="'Copy of '+template.name" :cloneGeoFunnels="false"
			                      @done="doneCloneFunnel" @failed="cloning=false"/>

		</div>
<!--		</transition>-->
	</div>
</template>

<script>
import API from "@/api"
import Loading from "@/components/Loading";
import VButton from "@/components/base/v-button";
import stepTypes from "@/helpers/stepTypes";
import shortValue from "@/helpers/shortValue";
import CloningFunnelPopup from "@/views/funnels/funnel-plus/funnel/cloning-funnel-popup";

export default {
	name: "TemplatePanel",
	props: {
		template: {
		    type: Object,
		},
	},
	components: {
		CloningFunnelPopup,
		VButton,
		Loading
	},
	mixins: [API],
	data() {
		return {
			cloning: false,
			steps: [],
			loading: false,
			liking: false,
		}
	},
	computed: {
	},
	methods: {
		doneCloneFunnel(funnel) {
			this.cloning=false;
			this.$router.push({path: `/wfunnel/${funnel.id}`});
		},
		short(v){
			return shortValue(v, 1)
		},
		stepType(type){
			if (type > 0) type -= 1;
			if (type >= stepTypes.length) type = 0;
			return stepTypes[type];
		},
		async like(){
			try {
				this.liking = true;
				this.template.liked = !this.template.liked;

				if (!this.template.liked) this.template.likes--;
				else this.template.likes++;

				await this.api.wsteps.likeTemplate(this.template.id, this.template.liked);

			} catch (e) {
				this.$warn(e)
			} finally {
				this.liking = false;
			}
		},
		async load(){
			try {
				this.loading = true;
				this.steps = [];
				this.steps = await this.api.wsteps.getTemplateSteps(this.template.funnel_id);

			} catch (e) {
				this.$warn(e)
			} finally {
				this.loading = false;
			}
		}
	},
	async created() {
		this.load();
	}
}
</script>
<style lang="scss" scoped>
.template-panel-popup {
	max-width: 500px;
	.popup_title {
		font-size: 24px;
		font-weight: bold;
	}
	.desc {
		margin-top: 10px;
	}
	.sub-tags {
		margin: 25px 0 25px;
		color: #636B7C;
		font-size: 14px;
		align-items: center;
		svg {
			margin-right: 5px;
			height: 14px;
		}
		.uses {
			margin-right: 20px;
			align-items: center;
		}
		.likes{
			align-items: center;
		}
	}
	.button {
		margin-right: 20px;
	}
	.template-steps {
		margin-top: 10px;
		padding-top: 10px;
		border-top: 1px solid $light-grey;
	}
	.like-btn {
		color: $blue;
		&.liked {
		}
	}
	.step-thumbnail {
		width: 100%;
		height: 200px;
		border: 1px solid $grey;
		overflow: hidden;
		border-radius: 3px;
		margin-bottom: 20px;
		position: relative;
		img {
			width: 100%;
			height: 200px;
			object-fit: cover;
			object-position: top;
			transition: 2s all ease-in;
		}
		&:hover {
			img {
				object-position: 0 50%;
			}
		}
		.tag {
			border-radius: 5px;
			border: 1px solid $grey;
			background: rgba(246, 249, 254, 0.95);
			color: $black;
			position: absolute;
			top: 5px;
			left: 10px;
			padding: 5px 10px;
			display: flex;
			flex-direction: row;
			align-items: center;
			img {
				margin-right: 5px;
				height: 18px;
				width: 18px;
			}
		}
	}
}

.popup_side_content {
	padding: 0;
}

.popup_left_side {
	padding: 0;
}

.product-name {
	max-width: 600px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	display: flex;
	padding: 20px 50px 20px 20px;

	> span {
		display: block;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
}


.automation-item .img-wrap img {
	display: block;
	width: 40px;
}
</style>
